function resize(element) {
  var newHeight = element.find(".image").outerHeight(true);
  var newWidth = element.find(".image").outerWidth(true);
  element.find(".lifestyleImage").css({
    height: newHeight,
    width: "100%",
  });
}

$(document).ready(function () {
  $(".item").hover(function () {
    resize($(this));
  });
});

$(window).resize(function () {
  $(".item").each(function () {
    resize($(this));
  });
});
